/**
 * Export data to CSV file (Excel-compatible with BOM for UTF-8).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function exportToExcel<T extends Record<string, any>>(
  data: T[],
  filename: string,
  columns: { key: keyof T; label: string }[],
) {
  const headers = columns.map((col) => col.label)
  const rows = data.map((item) =>
    columns.map((col) => {
      const value = item[col.key]
      return value !== null && value !== undefined ? String(value) : ''
    }),
  )

  const csvContent = [
    headers.join(','),
    ...rows.map((row) => row.map((cell) => `"${cell.replace(/"/g, '""')}"`).join(',')),
  ].join('\n')

  const BOM = '\uFEFF'
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = `${filename}_${new Date().toISOString().split('T')[0]}.csv`
  link.click()
  URL.revokeObjectURL(link.href)
}
